export default "__VITE_ASSET__26ee5098__"